const config =  {
  backendUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:8086' : 'https://openapi.playauto.io'
  // backendUrl: 'https://openapi.playauto.io'
};

Object.freeze(config);

export default config;